module.exports = __webpack_public_path__ + "img/830.00dc1df1.svg";